import React from 'react'
import { ListBtn } from './components'

const AiBtnList = ({
	btnID,
	items,
	itemDidTapped,
	itemWillShow,
	searchValue,
	isSmallScreen,
	itemType,
	onClick,
	onModalToggle
}) => (
	<div className="content-btn-list">
		{items.length
			?
			items.map((item, idx) => (
				<ListBtn
					btnID={btnID ? `${btnID}-${idx}` : ''}
					item={item}
					itemDidTapped={itemDidTapped}
					itemWillShow={itemWillShow}
					searchValue={searchValue}
					isSmallScreen={isSmallScreen}
					isQADefault={itemDidTapped.isDefault}
					itemType={itemType}
					onClick={onClick}
					onModalToggle={onModalToggle}
					key={idx}
				/>
			))
			:
			<div className='d-flex align-items-center justify-content-center margin-top-20'>
				{searchValue ? '查' : ''}無資料
			</div>}
	</div>
);


export { AiBtnList }
